/*!
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * Utility function used during template type checking to assert that a value is of a certain type.
 * @codeGenApi
 */
export function ɵassertType<T>(value: unknown): asserts value is T {}
